document.addEventListener("DOMContentLoaded", function () {
  if (window.__ppCartDrawerInitialized) return;
  window.__ppCartDrawerInitialized = true;

  var drawer = document.getElementById("cart-drawer");
  var overlay = document.getElementById("cart-drawer-overlay");
  var closeButton = document.getElementById("cart-drawer-close");
  var itemsContainer = document.getElementById("cart-drawer-items");
  var emptyState = document.getElementById("cart-drawer-empty");
  var footer = document.getElementById("cart-drawer-footer");
  var discountEl = document.getElementById("cart-drawer-discount");
  var subtotalEl = document.getElementById("cart-drawer-subtotal");
  var subtotalLabelEl = document.getElementById("cart-drawer-subtotal-label");
  var body = document.body;
  var addInFlight = false;
  var changeInFlightKeys = {};

  if (!drawer || !overlay) return;

  function formatMoney(cents, currency) {
    var amount = (cents || 0) / 100;
    var code = currency || "THB";
    return code + " " + amount.toLocaleString("th-TH", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function escapeHtml(str) {
    return (str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getLineDiscountTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (sum, item) {
      var originalLine = Number(item.original_line_price || 0);
      var finalLine = Number(item.final_line_price || 0);
      var lineDiscount = originalLine - finalLine;
      return sum + (lineDiscount > 0 ? lineDiscount : 0);
    }, 0);
  }

  function setOpen(open) {
    drawer.classList.toggle("is-open", open);
    overlay.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    body.classList.toggle("cart-drawer-open", open);
  }

  function renderCart(cart) {
    var hasItems = (cart.item_count || 0) > 0;
    var currency = cart.currency || "THB";

    if (!hasItems) {
      itemsContainer.innerHTML = "";
      emptyState.hidden = false;
      emptyState.style.display = "flex";
      footer.style.display = "none";
      subtotalLabelEl.textContent = "Subtotal (0 items)";
      subtotalEl.textContent = formatMoney(0, currency);
      discountEl.textContent = "-" + formatMoney(0, currency);
      updateCartCount(0);
      return;
    }

    emptyState.hidden = true;
    emptyState.style.display = "none";
    footer.style.display = "";

    itemsContainer.innerHTML = cart.items
      .map(function (item) {
        var finalPrice = item.final_price || 0;
        var originalPrice = item.original_price || finalPrice;
        var image = item.image || "";
        var title = item.product_title || item.title || "Item";
        var showDiscount = originalPrice > finalPrice;
        var removeIcon =
          '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5H17M6 2H12M7 9V15M11 9V15M4 5V17C4 18.1046 4.89543 19 6 19H12C13.1046 19 14 18.1046 14 17V5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var leftAction = item.quantity <= 1 ? "remove" : "decrease";
        var leftControl =
          leftAction === "remove"
            ? '<button class="cart-item__btn cart-item__btn--icon" data-qty-action="remove" aria-label="Remove item">' +
              removeIcon +
              "</button>"
            : '<button class="cart-item__btn" data-qty-action="decrease" aria-label="Decrease quantity">-</button>';

        return (
          '<div class="cart-item" data-item-key="' +
          escapeHtml(item.key) +
          '">' +
          '<div class="cart-item__image"><img src="' +
          escapeHtml(image) +
          '" alt="' +
          escapeHtml(title) +
          '"></div>' +
          '<div class="cart-item__info">' +
          '<h5 class="cart-item__title">' +
          escapeHtml(title) +
          "</h5>" +
          '<div class="cart-item__price">' +
          "<span>" +
          formatMoney(finalPrice, currency) +
          "</span>" +
          (showDiscount ? "<s>" + formatMoney(originalPrice, currency) + "</s>" : "") +
          "</div>" +
          "</div>" +
          '<div class="cart-item__qty">' +
          leftControl +
          '<span class="cart-item__qty-box">' +
          item.quantity +
          "</span>" +
          '<button class="cart-item__btn" data-qty-action="increase" aria-label="Increase quantity">+</button>' +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    var itemLabel = cart.item_count > 1 ? "items" : "item";
    var discountTotal = getLineDiscountTotal(cart);

    subtotalLabelEl.textContent = "Subtotal (" + cart.item_count + " " + itemLabel + ")";
    subtotalEl.textContent = formatMoney(cart.total_price, currency);
    discountEl.textContent = "-" + formatMoney(discountTotal, currency);
    updateCartCount(cart.item_count);
  }

  function getCart() {
    return fetch("/cart.js", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).then(function (res) {
      if (!res.ok) throw new Error("Unable to load cart.");
      return res.json();
    });
  }

  function extractErrorMessage(data, fallback) {
    if (!data) return fallback;
    if (typeof data === "string") return data;
    if (typeof data.description === "string" && data.description) return data.description;
    if (typeof data.message === "string" && data.message) return data.message;
    if (data.errors && typeof data.errors === "string") return data.errors;
    if (data.errors && Array.isArray(data.errors) && data.errors.length) return data.errors[0];
    if (data.errors && typeof data.errors === "object") {
      var firstKey = Object.keys(data.errors)[0];
      var firstVal = data.errors[firstKey];
      if (Array.isArray(firstVal) && firstVal.length) return firstVal[0];
      if (typeof firstVal === "string") return firstVal;
    }
    return fallback;
  }

  function parseErrorResponse(res, fallback) {
    return res
      .json()
      .then(function (data) {
        throw new Error(extractErrorMessage(data, fallback));
      }, function () {
        throw new Error(fallback);
      });
  }

  function normalizeVariantId(rawId) {
    var value = String(rawId || "").trim();
    if (!value) return "";
    var match = value.match(/(\d+)$/);
    return match ? match[1] : "";
  }

  function addToCart(variantId, quantity) {
    var normalizedId = normalizeVariantId(variantId);
    if (!normalizedId) return Promise.reject(new Error("Missing or invalid variant ID."));

    var body = new URLSearchParams();
    body.append("id", normalizedId);
    body.append("quantity", String(quantity || 1));

    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: body.toString(),
    }).then(function (res) {
      if (!res.ok) {
        if (res.status === 429) return parseErrorResponse(res, "Too many requests. Please wait a moment and try again.");
        if (res.status === 422) return parseErrorResponse(res, "This product cannot be added to cart right now.");
        return parseErrorResponse(res, "Unable to add item.");
      }
      return res.json();
    });
  }

  function changeCartItem(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) {
        if (res.status === 429) throw new Error("Too many requests. Please wait a moment and try again.");
        throw new Error("Unable to update cart.");
      }
      return res.json();
    });
  }

  function openDrawerWithRefresh() {
    return getCart()
      .then(function (cart) {
        renderCart(cart);
        setOpen(true);
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  function resolveVariantId(el) {
    var dataVariant = el.getAttribute("data-variant-id");
    if (dataVariant) return dataVariant;

    var form = el.closest("form");
    if (!form) return "";

    var idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : "";
  }

  function updateCartCount(count) {
    var badges = document.querySelectorAll(".cart-count-badge");
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle("has-items", count > 0);
    });
  }

  document.querySelectorAll(".header-cart-trigger, [data-cart-open]").forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      openDrawerWithRefresh();
    });
  });

  document.querySelectorAll(".add-to-cart, [data-add-to-cart]").forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      if (addInFlight) return;

      var variantId = resolveVariantId(button);
      if (!variantId) {
        console.warn("No variant id found for add-to-cart trigger.", button);
        return;
      }

      addInFlight = true;
      button.setAttribute("aria-disabled", "true");
      button.classList.add("is-loading");

      var qty = Number(button.getAttribute("data-quantity")) || 1;
      addToCart(variantId, qty)
        .then(function () {
          return openDrawerWithRefresh();
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          addInFlight = false;
          button.removeAttribute("aria-disabled");
          button.classList.remove("is-loading");
        });
    });
  });

  itemsContainer.addEventListener("click", function (e) {
    var actionBtn = e.target.closest("[data-qty-action]");
    if (!actionBtn) return;

    var row = actionBtn.closest("[data-item-key]");
    if (!row) return;

    var itemKey = row.getAttribute("data-item-key");
    var qtyEl = row.querySelector(".cart-item__qty-box");
    var currentQty = qtyEl ? Number(qtyEl.textContent) : 1;
    var action = actionBtn.getAttribute("data-qty-action");
    var nextQty = currentQty;

    if (action === "increase") nextQty = currentQty + 1;
    if (action === "decrease") nextQty = Math.max(0, currentQty - 1);
    if (action === "remove") nextQty = 0;
    if (changeInFlightKeys[itemKey]) return;

    changeInFlightKeys[itemKey] = true;
    changeCartItem(itemKey, nextQty)
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        changeInFlightKeys[itemKey] = false;
      });
  });

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      setOpen(false);
    });
  }

  overlay.addEventListener("click", function () {
    setOpen(false);
  });

  getCart()
    .then(function (cart) {
      renderCart(cart);
    })
    .catch(function () {
      updateCartCount(0);
    });
});
